<template>
	<div class="main-container">
		<h1 v-if="!dashboard">Build your ad</h1>
		<h1 v-if="dashboard">Ad status: <v-chip :color="sharedState.adInfo.approved ? 'success' : 'warning'">{{sharedState.adInfo.approved ? 'Approved' : 'Pending approval'}}</v-chip></h1>
		<AdComponent
			v-bind="sharedState.adInfo"
			:imageUrl="sharedState.adInfo.image"
		/>
		<form action method="post">
			<div class="form-row">
				<v-text-field
					class="form-input"
					label="Full name"
					outlined
					solo
					flat
					v-model="sharedState.adInfo.clientName"
					:height="50"
					color="#18125a"
				></v-text-field>
				<v-text-field
					class="form-input"
					label="Business name"
					v-model="sharedState.adInfo.businessName"
					outlined
					solo
					flat
					:height="50"
					color="#18125a"
				></v-text-field>
			</div>
			<div class="form-row">
				<v-text-field
					class="form-input"
					label="Line of work"
					v-model="sharedState.adInfo.lineWork"
					outlined
					solo
					flat
					:height="50"
					color="#18125a"
				></v-text-field>
				<v-text-field
					class="form-input"
					label="Full address"
					v-model="sharedState.adInfo.address"
					outlined
					solo
					flat
					:height="50"
					color="#18125a"
				></v-text-field>
			</div>
			<div class="form-row">
				<v-text-field
					class="form-input"
					label="Website"
					v-model="sharedState.adInfo.website"
					outlined
					solo
					flat
					:height="50"
					hide-details
					color="#18125a"
				></v-text-field>
				<v-text-field
					class="form-input"
					label="Phone number"
					v-model="sharedState.adInfo.phone"
					outlined
					solo
					flat
					:height="50"
					color="#18125a"
				></v-text-field>
			</div>
			<div class="form-row">
				<v-file-input
					class="form-input"
					style="width:100%;"
					outlined
					solo
					flat
					@change="onFileChange"
					label="Image"
				></v-file-input>
				<v-text-field
					class="form-input"
					label="Custom message"
					v-model="sharedState.adInfo.shortDescription"
					outlined
					solo
					flat
					:height="50"
					color="#18125a"
				></v-text-field>
			</div>
			<div class="action-buttons">
				<button type="button" class="next-button" @click="onFinishAd" v-if="!dashboard">Finish ad</button>
				<button type="button" class="next-button" @click="onUpdateAd" v-if="dashboard">Update ad spot</button>
			</div>
		</form>
	</div>
</template>

<script>
import AdComponent from "@/components/AdComponent";
import store from "@/services/business/store";

export default {
	name: "AdEditComponent",
	components: {
		AdComponent
	},
	props: {
		dashboard: Boolean,
		fetch: Boolean
	},
	data: () => {
		return {
			fileImage: null,
			name: null,
			sharedState: store.state
		};
	},
	methods: {
		onFileChange(e) {
			this.fileImage = e;
			this.sharedState.adInfo.fileImage = e;
			this.sharedState.adInfo.image = URL.createObjectURL(e);
        },
        onFinishAd() {
            this.$emit('adFinished');
		},
		onUpdateAd() {
			this.$emit('updated');
		},
		onBack() {
			this.$emit('back');
		}
	},
	created() {
		if (this.fetch) {
			store.getSpot();
		}
	}
};
</script>

<style lang="scss" scoped>
	.main-container {
		display: flex;
		flex-direction: column;
		padding: 0px 80px;

		h1 {
			font-size: 3rem;
			color: #18125a;
			text-align: center;
			margin-bottom: 20px;
		}

		form {
			display: flex;
			flex-direction: column;
			width: 100%;
			align-items: center;
			margin-top: 50px;

			.form-row {
				display: flex;
				flex-direction: row;
				width: 100%;
				justify-content: center;
			}

			.form-input:first-child {
				margin-right: 25px;
			}

			.form-input {
				max-width: 425px;
			}

			.action-buttons {
				display: flex;
				flex-direction: row;
				width: 100%;
				justify-content: space-around;

				.back-button {
					background-color: transparent;
					color: #e79831;
					border: 1px solid #e79831;
					font-weight: bold;
					width: 100%;
					max-width: 200px;
					height: 50px;
					padding: 5px;
					border-radius: 5px;
					font-size: 1rem;
				}

				.next-button {
					background: #e79831;
					color: white;
					font-weight: bold;
					width: 100%;
					max-width: 200px;
					height: 50px;
					padding: 5px;
					border-radius: 5px;
					font-size: 1rem;
				}
			}
		}
	}

	@media screen and (max-width: 600px) {
		.main-container {
			padding: 20px;

			h1 {
				font-size: 2rem;
				line-height: 2.5rem;
			}
		}
	}
</style>